export var ERROR_CODES = /*#__PURE__*/ function(ERROR_CODES) {
    ERROR_CODES["badGateway"] = "bad-gateway";
    ERROR_CODES["conflict"] = "conflict";
    ERROR_CODES["denied"] = "access-denied";
    ERROR_CODES["forbidden"] = "forbidden";
    ERROR_CODES["gatewayTimeout"] = "gateway-timeout";
    ERROR_CODES["internalServerError"] = "internal-server-error";
    ERROR_CODES["invalid"] = "validation-failed";
    ERROR_CODES["notFound"] = "not-found";
    ERROR_CODES["notImplemented"] = "not-implemented";
    ERROR_CODES["paymentRequired"] = "payment-required";
    ERROR_CODES["rateLimit"] = "rate-limit";
    ERROR_CODES["unknown"] = "unknown";
    return ERROR_CODES;
}({});

//# sourceMappingURL=errors.js.map